import React from "react";
import loadingSvg from "../../../assets/images/loadingSvg.svg";
import "./loading.css";

const Loading = ({ title }) => {
  return (
    <div className="loadingContainer">
      <img className="loadingImage" src={loadingSvg} alt="empty" />
      <span className="loadingTitle">{title}</span>
    </div>
  );
};
export default Loading;
